import { render, staticRenderFns } from "./LKNotificationPagesView.vue?vue&type=template&id=399ca8c6&"
import script from "./LKNotificationPagesView.vue?vue&type=script&lang=js&"
export * from "./LKNotificationPagesView.vue?vue&type=script&lang=js&"
import style0 from "./LKNotificationPagesView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports